import { useContext } from "react";
import { AppContext } from "../../App";

function Flows() {
	const { activeFlow, setActiveFlow, apiSettings, table, cart } = useContext(AppContext);
	const configuredFlows = apiSettings?.orders?.flows_number
		? parseInt(apiSettings.orders.flows_number)
		: 5;
	const isFlowsEnabled = Number(
		apiSettings?.orders?.enable_flow ?? apiSettings?.orders?.enable_flows ?? 1,
	);
	const orderMaxFlow = (cart?.products || []).reduce((max, product) => {
		const flow = parseInt(product?.flow) || 1;
		return flow > max ? flow : max;
	}, 1);
	const totalFlows = Math.max(configuredFlows, orderMaxFlow);
	const flows = [...Array(totalFlows).keys()];

	if (isFlowsEnabled === 0) return null;
	if (!cart.table) return null;
	if (table.single_order_mode == 1) return null;

	return (
		<div className="cart-flows-buttons">
			{flows.map((el, i) => (
				<button
					key={i}
					className={activeFlow == el + 1 ? "selected" : ""}
					onClick={() => setActiveFlow(el + 1)}
				>
					{"Portata " + (el + 1)}
				</button>
			))}
		</div>
	);
}

export default Flows;
